import { AlertService } from './../services/alert.service';
import { catchError } from 'rxjs/operators';
import { DialogService } from '@shared/@fuse/components/dialog/dialog.service';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNil, isEmpty } from 'lodash';
import { LoadingService } from '@core/services/loading.service';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { SessionService } from '@core/services/session.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthTokenHeaderInterceptor implements HttpInterceptor {
    constructor(
        private alertService: AlertService,
        private dialogService: DialogService,
        private loadingService: LoadingService,
        private router: Router,
        private sessionService: SessionService,
        private translateService: TranslateService
    ) {}

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 403 && !this.router.url.endsWith('/auth/login')) {
            this.loadingService.hide();
            this.sessionService.destroySession();
            this.dialogService.closeAll();
            this.router.navigate(['/', this.sessionService.currentLang, 'auth', 'login'], {
                queryParams: { returnUrl: this.router.url }
            });
            const errorMessage = this.translateService.instant('common.notification.session_timeout');
            return this.alertService.notifyText(errorMessage);
        } else {
            return throwError(err);
        }
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const accessToken = this.sessionService.getAuthToken();
        if (!isNil(accessToken) && !isEmpty(accessToken) && isNil(request.headers.get('is-external'))) {
            request = request.clone({ setHeaders: { Authorization: accessToken } });
            return next.handle(request).pipe(catchError((err) => this.handleAuthError(err)));
        } else {
            return next.handle(request);
        }
    }
}
